import axios  from '@/axios.js';
import router from '@/router.js';
import state  from './state';

export default {
  /* Articles */
  async changeArticlesPage({ commit, dispatch }, page) {
    if (state.articlesLoading) {
      return;
    }

    if (state.articlesPage === page) {
      return;
    }

    if (page < 1) {
      return;
    }

    if (page > state.articlesPageLast) {
      return;
    }

    commit('ARTICLES_PAGE', page);

    /* Fetch articles after changing the parameters */
    dispatch('fetchArticles');
  },

  async changeArticlesSearch({ commit, dispatch }, search) {
    if (state.articlesLoading) {
      return;
    }

    if (state.articlesSearch === search) {
      return;
    }

    if (search !== null && search.trim() === '') {
      return;
    }

    if (search === null) {
      router.push({ query: {} });
    } else {
      router.push({ query: { q: search } });
    }

    commit('ARTICLES_SEARCH', search ?? '');
    commit('ARTICLES_PAGE'  , 1);

    /* Fetch articles after changing the parameters */
    dispatch('fetchArticles');
  },

  async fetchArticles({ commit })  {
    if (state.articlesLoading) {
      return;
    }

    state.articlesLoading = true;
    let url = '/articles?per_page=4';

    if (state.articlesPage !== 1) {
      url = `${ url }&page=${ state.articlesPage }`;
    }

    if (state.articlesSearch !== '') {
      url = `${ url }&q=${ state.articlesSearch }`;
    }

    if (state.categoriesCurrent !== null) {
      url = `${ url }&category_id=${ state.categoriesCurrent.id }`;
    }

    window.scrollTo(0, 0);
    const request = await axios.get(url);

    if (request.data.success === false) {
      request.data.articles           = {};
      request.data.articles.data      = [];
      request.data.articles.last_page = 1;
    }

    commit('ARTICLES'          , request.data.articles.data);
    commit('ARTICLES_PAGE_LAST', request.data.articles.last_page);
  },

  async fetchArticlesTop({ commit })  {
    if (state.articlesTopLoading) {
      return;
    }

    state.articlesTopLoading = true;
    const request = await axios.get('/articles/top');

    commit('ARTICLES_TOP', request.data.articles.slice(0, 5));
  },

  /* Categories */
  async changeCategoriesCurrent({ commit, dispatch }, category) {
    if (state.categoriesLoading) {
      return;
    }

    if (state.categoriesCurrent === category) {
      return;
    }

    commit('CATEGORIES_CURRENT', category);
    commit('ARTICLES_PAGE'     , 1);

    /* Fetch articles after changing the parameters */
    dispatch('fetchArticles');
  },

  async fetchCategories({ commit })  {
    if (state.categoriesLoading) {
      return;
    }

    state.categoriesLoading = true;
    const request = await axios.get('/global/categories');

    commit('CATEGORIES', request.data.categories);
  },

  ///USED IN SPECIALIST MY ARTICLES
  async fetchSpecialistArticles({commit}, id) {
    axios.get('/specialist/articles')
              .then(function (response) {
                commit('SPECIALIST_ARTICLES', response);
                state.isLoading = false;
            })
            .catch(function (error) {
                dispatch('notification/notification', error.response, { root: true })
            });
  }
}
